import ShButton from './standard'

export default ShButton
